export default __webpack_public_path__ + "static/media/monkey_dark_female.26ead44b.png";